<template>
	<div>
		<el-form :inline="true" :model="searchForm" ref="searchForm">
			<el-form-item label="规则名称" prop="name" label-width="80px">
				<el-input v-model="searchForm.name" placeholder="规则名称" clearable> </el-input>
			</el-form-item>
			<!-- <el-form-item label="备注" prop="remark" label-width="50px">
				<el-input v-model="searchForm.remark" placeholder="备注" clearable> </el-input>
			</el-form-item> -->
			<!-- <el-form-item label="类型" prop="type" label-width="50px">
				<el-select v-model="searchForm.type" filterable placeholder="选择类型">
					<el-option v-for="(item, index) in typeList" :key="index" :label="item.name" clearable
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item>
				<el-button type="success" @click="getRule()">搜索</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="success" @click="resetForm('searchForm')">重置</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="addUpdateRuleButton(0)">
					添加规则分类
				</el-button>
			</el-form-item>
		</el-form>

		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe
			@selection-change="handleSelectionChange">
			<el-table-column prop="name" align="center" label="规则名称"></el-table-column>
			<el-table-column align="center" label="备注" prop="remark"></el-table-column>
			<el-table-column prop="type" align="center" label="类型">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.type === 0" type="success"> 满足数量 </el-tag>
					<!-- <el-tag size="small" v-else-if="scope.row.type === 1" type="success"> 满足金额 </el-tag> -->
				</template>
			</el-table-column>
			<el-table-column prop="createTime" align="center" label="创建时间"></el-table-column>
			<el-table-column prop="icon" align="center" fixed="right" label="操作">
				<template slot-scope="scope">
					<el-button type="info" plain @click="watchRuleReward(scope.row)">查看规则奖励</el-button>
					<el-button type="primary" plain @click="updateRuleButton(scope.row, 1)">编辑</el-button>
					<el-popconfirm title="确定要删除这个分类吗？" @confirm="delRule(scope.row.id)">
						<el-button type="danger" slot="reference">删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页器 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total"></el-pagination>
		<!-- 对话框 -->
		<el-dialog :title="(addOrUpdate ? '修改' : '添加') + '规格分类'" :visible.sync="dialogVisible" :close-on-click-modal="false"
			:before-close="handleClose">
			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">
				<el-form-item label="规则名称" prop="name" label-width="150px">
					<el-input v-model="editForm.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注" prop="remark" label-width="150px">
					<el-input v-model="editForm.remark" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="规则类型" prop="type" label-width="150px">
					<el-radio-group v-model="editForm.type">
						<el-radio :label="0">满足数量</el-radio>
						<!-- <el-radio :label="1">满足金额</el-radio> -->
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit('editForm')">确定</el-button>
			</div>
		</el-dialog>
		<RuleReward ref="RuleReward"></RuleReward>
	</div>
</template>

<script>
import RuleReward from './RuleReward.vue';
export default {
	components: {
		RuleReward
	},
	data() {
		return {
			//搜索数据
			searchForm: {
				name: '',
				remark: '',
				type: ''
			},
			// delBtlStatu: true,
			tableData: [],
			
			// multipleSelection: [],
			// 添加或编辑数据
			addOrUpdate: 0,
			// 编辑数据id
			editId: '',
			total: 0,
			
			// 每页多少数据
			size: 10,
			
			// 那一页
			current: 1,
			currents: 1,
			typeList: [
				{ name: '满足数量', id: 0 },
				// { name: '满足金额', id: 1 }
			],
			//对话框是否展示
			dialogVisible: false,
			// 编辑数据
			editForm: {
				name: '',
				remark: '',
				type: 0
			},
			//表单校验规则
			editFormRules: {
				name: [{
					required: true,
					message: '请输入规则名称',
					trigger: 'blur'
				}],
				type: [{
					required: true,
					message: '请选择规则类型',
					trigger: 'change'
				}]
			},
		}
	},
	created() {
		this.getRule()
	},
	methods: {
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.getRule()
			this.editForm = {
				name: '',
				remark: '',
				type: 0
			}
		},
		handleSelectionChange(val) {
			// this.multipleSelection = val
			// this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			console.log('size changed', val);
			this.size = val
			this.getRule()
		},
		handleCurrentChange(val) {
			console.log('current changed', val);
			this.current = val
			this.getRule()
		},
		// 关闭对话框触发事件
		handleClose() {
			this.resetForm('editForm')
		},
		//获取规则列表
		getRule() {
			let obj = {}
			if (this.searchForm.name) {
				obj.name = this.searchForm.name
			}
			if (this.searchForm.remark) {
				obj.remark = this.searchForm.remark
			}
			console.log(this.searchForm.type != '');

			if (this.searchForm.type == 0 || this.searchForm.type == 1) {
				obj.type = this.searchForm.type
			}
			obj.pageNo = this.current
			obj.pageSize = this.size
			this.$axios.post('/admin/rule/list', obj).then((res) => {
				console.log(33333333, res);
				this.tableData = res.data.records
				this.tableData.forEach((item) => {
					item.createTime = this.formateDate(item.createTime)
				});
				this.size = res.data.size
				this.current = res.data.current
				this.total = res.data.total
			})
		},
		//编辑规则分类
		updateRuleButton(val, key) {
			this.addOrUpdate = key
			this.editForm.name = val.name
			this.editForm.remark = val.remark
			this.editForm.type = val.type
			this.editId = val.id
			this.dialogVisible = true
		},
		//删除规则
		delRule(id) {
			console.log(id);
			this.$axios
				.post('/admin/rule/delete', { id: id }).then((res) => {
					console.log(res);
					if (res.code == 0) {
						this.getRule()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
						})
					}
				})
		},

		//添加规则分类(打开对话框)
		addUpdateRuleButton(val) {
			this.dialogVisible = true
			this.addOrUpdate = val
		},
		submit(formName) {
			if (this.addOrUpdate == 0) {
				// 添加规则分类
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$axios.post('/admin/rule/add', this.editForm).then((res) => {
							if (res.code == 0) {
								this.getRule()
								this.handleClose()
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
								})
							}
						})
					}
				})
			} else if (this.addOrUpdate == 1) {
				// 编辑规则分类
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let obj = Object.assign({}, this.editForm, { id: this.editId })
						this.$axios.post('/admin/rule/update', obj).then((res) => {
							if (res.code == 0) {
								this.getRule()
								this.handleClose()
								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
								})
							}
						})
					}
				})
			}
		},
		watchRuleReward(obj) {
			this.$refs.RuleReward.openOuterDialog(obj.id, obj.type)
		},
		//格式化时间
		formateDate(isoDate) {
			if (isoDate) {
				// 1. 创建 Date 对象（自动解析 ISO 字符串）
				const date = new Date(isoDate);

				// 2. 转换为中国时间（UTC+8）
				const chinaTimeOffset = 8 * 60 * 60 * 1000; // 8小时的毫秒数
				const chinaTime = new Date(date.getTime() + chinaTimeOffset);

				// 3. 提取日期时间组件（使用 UTC 方法避免本地时区干扰）
				const year = chinaTime.getUTCFullYear();
				const month = String(chinaTime.getUTCMonth() + 1).padStart(2, '0');
				const day = String(chinaTime.getUTCDate()).padStart(2, '0');
				const hours = String(chinaTime.getUTCHours()).padStart(2, '0');
				const minutes = String(chinaTime.getUTCMinutes()).padStart(2, '0');
				const seconds = String(chinaTime.getUTCSeconds()).padStart(2, '0');

				// 4. 组合成目标格式
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			} else {
				return ''
			}
		}
	},
}
</script>

<style scoped>
.el-button {
	padding: 0 10px;
	height: 35px;
	line-height: 35px;
	font-size: 15px;
	margin-right: 10px;
}
</style>